var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 12,
    fill: "#F7F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 24.9656L19.3892 24.6653C19.8265 24.328 20.4544 24.409 20.7918 24.8463C21.1291 25.2836 21.0481 25.9115 20.6108 26.2489L18.6277 27.7787C18.5675 27.8274 18.5025 27.8682 18.4342 27.901C18.3808 27.928 18.309 27.9545 18.234 27.9725C18.1375 27.9951 18.0448 28.0033 17.953 27.9989C17.812 27.9924 17.6786 27.9567 17.5588 27.8976C17.4931 27.8654 17.4305 27.8257 17.3723 27.7787L15.3892 26.2489C14.9519 25.9115 14.8709 25.2836 15.2082 24.8463C15.5456 24.409 16.1735 24.328 16.6108 24.6653L17 24.9656V14.4571C17 13.9048 17.4477 13.4571 18 13.4571C18.5523 13.4571 19 13.9048 19 14.4571V24.9656V24.9656ZM18.5 8C21.0609 8 23.2376 9.76105 23.8369 12.1724C26.2436 12.7736 28 14.9541 28 17.518C28 20.3327 25.8828 22.6868 23.1101 22.9939C22.5612 23.0547 22.0669 22.659 22.0061 22.1101C21.9453 21.5612 22.341 21.0669 22.8899 21.0061C24.6514 20.8109 26 19.3114 26 17.518C26 15.7174 24.6408 14.214 22.8706 14.0278C22.4009 13.9784 22.0298 13.6072 21.9806 13.1375C21.7947 11.3618 20.2947 10 18.5 10C16.7037 10 15.2029 11.3641 15.0189 13.1417C14.9615 13.696 14.4622 14.0964 13.9087 14.0321C13.7739 14.0164 13.6376 14.0085 13.5 14.0085C11.5675 14.0085 10 15.5793 10 17.518C10 19.3114 11.3486 20.8109 13.1101 21.0061C13.659 21.0669 14.0547 21.5612 13.9939 22.1101C13.9331 22.659 13.4388 23.0547 12.8899 22.9939C10.1172 22.6868 8 20.3327 8 17.518C8 14.575 10.3038 12.1702 13.2043 12.0163C13.8571 9.68561 15.9945 8 18.5 8Z",
    fill: "#B5B5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/Download-Icon.445a6d1534abbb766ac189f89e25530f.svg";
export { ForwardRef as ReactComponent };